import {initPhotoPopups} from './components/photoswipe';
import initReviews from "./screens/product/vote_reviews";

initPhotoPopups();
initReviews();
